import { useEffect, useState, useContext } from "react";
import api from "../api/api";
import AuthContext from "../store/auth-context";

export default function () {
  const authCtx = useContext(AuthContext);
  const [isRaceAdmin, setIsRaceAdmin] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoadingAdminCheck, setIsLoadingAdminCheck] = useState(false);
  useEffect(() => {
    const checkIfAdmin = async () => {
      try {
        setIsLoadingAdminCheck(true);
        const adminResponse = await api.get(`/auth/check-if-admin/`, {
          headers: {
            Authorization: "Bearer " + authCtx.token,
          },
        });
        setIsRaceAdmin(adminResponse.data.isRaceAdmin);
        setIsAdmin(adminResponse.data.isAdmin);
        setIsLoadingAdminCheck(false);
      } catch (err) {
        setIsLoadingAdminCheck(false);
        console.log(err);
      }
    };
    if (!authCtx.token) {
      setIsRaceAdmin(false);
      setIsAdmin(false);
      return;
    }
    checkIfAdmin();
  }, [authCtx.token]);
  return { isAdmin, isRaceAdmin, isLoadingAdminCheck };
}
